// .storybook/manager.js

import { addons } from '@storybook/manager-api';

const theme = {
	base: 'dark',
	brandTitle: 'Elbuild guide',
	brandImage: 'https://www.elbuild.it/assets/logo.svg',
	brandTarget: '_self',
}
addons.setConfig({
	isFullscreen: false,
	showNav: true,
	showPanel: true,
	panelPosition: 'bottom',
	enableShortcuts: true,
	showToolbar: true,
	theme: theme,
	selectedPanel: undefined,
	initialActive: 'sidebar',
	sidebar: {
		showRoots: true,
		collapsedRoots: ['other'],
	},
	toolbar: {
		title: { hidden: false },
		zoom: { hidden: false },
		eject: { hidden: false },
		copy: { hidden: false },
		fullscreen: { hidden: false },
	},
});
